import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

const RadioButtonsPicker = ({ items, onChange, title, defaultId, value }) => {
  const [activeItemId, setActive] = useState(value || defaultId);
  useEffect(() => {
    // If it's not send it works without that
    if (value) {
      setActive(value);
    }
  }, [value, setActive]);

  return (
    <div className={'radio-buttons-picker-container'}>
      {title && <label className="styled-label">{title}</label>}
      <div className="radio-buttons-wrapper">
        {items && (
          <Radio.Group
            value={activeItemId}
            onChange={(e) => {
              setActive(e.target.value);
              onChange(e.target.value);
            }}
          >
            {items.map((item) => {
              return (
                <Radio key={item.id} value={item.id}>
                  {item.label}
                </Radio>
              );
            })}
          </Radio.Group>
        )}
      </div>
    </div>
  );
};

RadioButtonsPicker.propTypes = {
  items: PropTypes.array,
  onChange: PropTypes.func,
  title: PropTypes.string,
  defaultId: PropTypes.string,
  value: PropTypes.any,
};

export default RadioButtonsPicker;
